import React, { useEffect } from "react";
import { Form, Radio } from "antd";
import { grbsOptions } from "../../../IpEMR/Options/careItemsOptions";
import { DeleteOutlined } from "@ant-design/icons";

const AiGrbsForm = ({ form, onDelete, editData }) => {
  useEffect(() => {
    if (editData?.monitoring?.grbs?.frequency) {
      form.setFieldValue(
        ["care_items", "grbs_monitoring", "data", "grbs_monitoring"],
        editData?.monitoring?.grbs?.frequency
      );
    }
  }, [editData]);
  return (
    <div
      style={{
        display: "flex",
        gap: "12px",
        alignItems: "flex-start",
        padding: "12px 0",
      }}
    >
      <div style={{ flex: 1 }}>
        <Form.Item
          name={["care_items", "grbs_monitoring", "data", "grbs_monitoring"]}
          label="GRBS Monitoring"
          rules={[{ required: true, message: "Please select an option" }]}
        >
          <Radio.Group options={grbsOptions} />
        </Form.Item>
      </div>

      <DeleteOutlined
        onClick={() => {
          form.setFieldValue(["monitoring", "grbs"], null);
          onDelete(); // 🔥 hides the entire form
        }}
        style={{
          color: "red",
          fontSize: "20px",
          cursor: "pointer",
          marginTop: "30px",
        }}
      />
    </div>
  );
};

export default AiGrbsForm;
